import React from 'react';
import { connect } from 'react-redux';
import PasswordResetVerify from '../../components/templates/PasswordResetVerify';
import { authOperations } from '../../reducks/auth';
import { commonOperations } from '../../reducks/common';

const mapStateToProps = state => ({
  currentTheme: state.style.theme,
});

const mapDispatchToProps = {
  passwordResetAction: authOperations.doPasswordResetOperation,
  doOpenDialog: commonOperations.doOpenDialog,
};

class App extends React.Component {

  componentDidMount() {
    window.scrollTo(0, 0);
  }

  render() {
    return (<PasswordResetVerify
      {...this.props}
    />);
  }
}
const ContainerApp = connect(
  mapStateToProps,
  mapDispatchToProps
)(App);

export default ContainerApp;
